<template>
  <div class="app-activate-auto-top-up-wrapper">
    <activate-auto-top-up
      v-if="showActivated"
      :monthly-value="monthlyValue"
      :next-step="gotoSuccess"
      :topUp.sync = "topUp"
    >
      <template #txtBeforeAutoTopUp><slot name="txtBeforeActivateAutoTopUp"></slot></template>
      <template #btnNext><slot name="btnActivateNext"></slot></template>
      <template #txtHeaderMonthlyAutoTopUp><slot name="txtActivateHeaderMonthlyAutoTopUp"></slot></template>
      <template #txtHeaderMonthlyInsideAutoTopUp><slot name="txtActivateHeaderMonthlyInsideAutoTopUp"></slot></template>
      <template #lblMonthlyAutoTopUp><slot name="lblActivateMonthlyAutoTopUp"></slot></template>
      <template #lblMonthlyAmountAutoTopUp><slot name="lblActivateMonthlyAmountAutoTopUp"></slot></template>
      <template #txtDescByLimitAutoTopUp><slot name="txtDescByLimitAutoTopUpAutoTopUp"></slot></template>
      <template #txtHeaderByLimitAutoTopUp><slot name="txtActivateHeaderByLimitAutoTopUp"></slot></template>
      <template #txtHeaderByLimitInsideAutoTopUp><slot name="txtActivateHeaderByLimitInsideAutoTopUp"></slot></template>
      <template #lblByLimitAutoTopUpFirst><slot name="lblActivateByLimitAutoTopUpFirst"></slot></template>
      <template #lblByLimitAutoTopUpSecond><slot name="lblActivateByLimitAutoTopUpSecond"></slot></template>
    </activate-auto-top-up>
    <Success
      v-if="showSuccess"
      :back="backToActivate"
    >
      <template #txtBefore><slot name="txtAutoTopUpSuccessActivated"></slot></template>
      <template #btnSuccessBack><slot name="btnAutoTopUpActivatedSuccessBack"></slot></template>
      <template #txtAfter><slot name="txtAutoTopUpSuccessActivatedAfter"></slot></template>
    </Success>
  </div>
</template>
<script>
import Success, { stepName as successStepName } from '../../../../generic/Success2.vue'
import { mapGetters, mapMutations } from 'vuex'
import ActivateAutoTopUp, { stepName as activateStepName } from './ActivateAutoTopUp.vue'
export default {
  name: 'ActivateAutoTopUpWrapper',
  data () {
    return {
      topUp: {
        amount: 0,
        trigger: 0,
        type: null
      }
    }
  },
  created () {
    this.setActivationView(activateStepName)
  },
  computed: {
    ...mapGetters('topUp', [
      'getActivationView'
    ]),
    gotoSuccess () {
      return successStepName
    },
    showActivated () {
      return this.getActivationView === activateStepName
    },
    showSuccess () {
      return this.getActivationView === successStepName
    }
  },
  methods: {
    backToActivate () {
      this.$emit('refresh')
    },
    ...mapMutations('topUp', [
      'setActivationView'
    ])
  },
  props:
    [
      'monthlyValue',
      'autoTopUp'
    ],
  components: { ActivateAutoTopUp, Success }
}
</script>
